import { UseQueryResult, useQuery } from "react-query";
import { ListCarsResponse, listCars } from "../../../../entities/car/api/list-cars";

export interface UseListCarsProps {
  term: string;
  startDate: Date;
  endDate: Date;
  page: number;
  limit: number;
  shouldListByDate: boolean;
  enabled: boolean;
}

export const queryKeys = {
  listCars: (props: UseListCarsProps) => ["listCars", props]
};

export function useListCars(props: UseListCarsProps): UseQueryResult<ListCarsResponse, Error> {
  const { term, page, limit, enabled } = props;

  return useQuery(
    queryKeys.listCars(props),
    async () => {
      const result = await listCars({
        plate: term,
        chassi: term,
        limit: limit,
        offset: (page - 1) * limit,
        costumerId: ""
      });
      
      if (result.error) {
        throw new Error(result.error.message || "Error searching cars");
      }
      
      return {
        cars: result.cars,
        total: result.total
      };
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: enabled
    }
  );
}
